export function checkUnicodeString(str = "") {
  // an UNICODE formated string will start with \u for each char
  return str.startsWith("\\u", 0);
}
